import {
  COURIER,
  COURIER_DELIVERY_SERVICE,
  SELLER_SHIPMENT_TYPE,
  NON_SELLER_SHIPMENT_TYPE } from 'domains/seller-outbound-return/constants'
import * as Yup from 'yup'
import StringUtil from 'utils/string-util'

/** Create Outbound return schema */
const sellerOutboundReturnAddressSchema = Yup.object().shape({
  courier: Yup.string().oneOf(
    Object.values(COURIER),
    `Must be one of this value: ${Object.values(COURIER).map((values) => StringUtil.titleCase(values)).join(', ')}`
  ).required('Required'),
  shipment_type: Yup.string().when('courier', {
    is   : (value) => value === COURIER.SELLER,
    then : Yup.string().oneOf(
      Object.values(SELLER_SHIPMENT_TYPE),
      `Must be one of this value: ${Object.values(SELLER_SHIPMENT_TYPE).map((values) => StringUtil.titleCase(values)).join(', ')}`
    ).required('Required'),
    otherwise: Yup.string().oneOf(
      Object.values(NON_SELLER_SHIPMENT_TYPE),
      `Must be one of this value: ${Object.values(NON_SELLER_SHIPMENT_TYPE).map((values) => StringUtil.titleCase(values)).join(', ')}`
    ).required('Required')
  }),
  tracking_no: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  street_address: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  tl_district_id: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  tl_sub_district_id: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  tl_city_id: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  tl_province_id: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  }),
  // TODO: might change it to string after migrating Seller model to use tl addresses
  postal_code: Yup.string().when('courier', {
    is   : (value) => Object.values(COURIER_DELIVERY_SERVICE).includes(value),
    then : Yup.string().required('Required')
  })
})

export default sellerOutboundReturnAddressSchema
